import React, { useEffect, useMemo, useRef, useState } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import "../ag-table.css";

import FutureMonthRowData from "./FutureMonthRowData";
import { futureMonthColDef } from "./futureMonthColDef";

import ModalComponent from "../ModalComponent";
import { useModalContext } from "../ModalContext";
import { currencyFormat, getFutureMonthDatesAsia } from "../helpers";
import { Box, Button } from "@mui/material";
import { TYPES } from "../constants";
import BasicSelect from "../components/BasicSelect";
import LoadingSpinner from "../components/LoadingSpinner";
import AddNewProductModal from "../components/AddNewProductModal";
import { fetchEditPermissions } from "../api/editpermissions";

const FutureMonth = ({ open }) => {
  const [type, setType] = useState(TYPES[0]);
  const [rowIndex, setRowIndex] = useState();
  const [activeFilters, setActiveFilters] = useState([]);
  const { loading, data: rowData } = FutureMonthRowData(type);
  const [colDefs] = useState(futureMonthColDef);
  const gridApiRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const { openModalWithAGValues } = useModalContext();

  //edit-permission

  useEffect(() => {
    const fetchPermission = async () => {
      const permissions = await fetchEditPermissions();
      setIsButtonEnabled(permissions.Future_Month === 1);
    };

    fetchPermission();
  }, []);

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const updateRowData = (data) => {
    if (data) {
      if (gridApiRef.current) {
        const rowNode = gridApiRef.current.getRowNode(rowIndex);
        if (rowNode) {
          rowNode.setData(data);
          gridApiRef.current.refreshClientSideRowModel("aggregate");
        } else {
          console.error("Row node not found for ID:", rowIndex);
        }
      }
    }
  };
  const onCellClicked = (event) => {
    setRowIndex(event.node.id);
    // const date = new Date();
    // const today = date.getDate();
    const fields = Array.from({ length: 31 }, (v, i) => i.toString());

    // Check if the clicked row is a group row
    const isGroupRow = event.node.group;

    if (
      fields.includes(event.colDef.field) &&
      event.colDef.field &&
      !isGroupRow
    ) {
      openModalWithAGValues(
        event.data,
        event.colDef.field,
        event.data.Warehouse,
        "",
        "",
        getFutureMonthDatesAsia()
      );
    }

    if (event.colDef.field === "M" && event.colDef.field && !isGroupRow) {
      openModalWithAGValues(
        event?.data,
        event.colDef.field,
        event?.data?.Warehouse,
        "",
        "",
        getFutureMonthDatesAsia()
      );
    }
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 300,
      cellRendererParams: {
        totalValueGetter: (params) => {
          const isRootLevel = params.node.level === -1;
          if (isRootLevel) {
            return "Grand Total";
          }
          return `Sub Total (${currencyFormat(params.value)})`;
        },
      },
    };
  }, []);

  const sideBar = {
    toolPanels: [
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ],
    defaultToolPanel: "",
  };
  const handleGetFilters = () => {
    const filterModel = gridApiRef.current.getFilterModel();
    setActiveFilters(filterModel);
  };

  //add new product

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div
      className='ag-table-container'
      style={{ marginLeft: open ? "240px" : "0px" }}
    >
      <div style={{ display: "flex", alignItems: "start", gap: "20px" }}>
        {loading && <LoadingSpinner />}
        <div style={{ marginBottom: "20px" }}>
          <Box sx={{ display: "inline-flex" }}>
            <BasicSelect
              value={type}
              setValue={setType}
              name='Type'
              options={TYPES}
            />
          </Box>
          <Button
            variant='contained'
            disabled={!isButtonEnabled}
            onClick={handleOpenModal}
            style={{
              minWidth: "150px",
              minHeight: "55px",
              flexGrow: 1,
              marginLeft: "8px",
              backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
              color: !isButtonEnabled ? "#9e9e9e" : "#fff",
              cursor: !isButtonEnabled ? "not-allowed" : "pointer",
            }}
            color='primary'
            size='medium'
          >
            Add New Product
          </Button>
        </div>
      </div>
      <div className='ag-theme-quartz' style={{ height: 650 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          pivotMode={false}
          sideBar={sideBar}
          onCellClicked={onCellClicked}
          autoGroupColumnDef={autoGroupColumnDef}
          groupTotalRow={"top"}
          grandTotalRow={"top"}
          onGridReady={onGridReady}
          onFilterChanged={handleGetFilters}
          getRowId={(params) => params.data.id}
          suppressAggFuncInHeader={true}
        />
      </div>
      <ModalComponent
        activeFilters={activeFilters}
        updateRowData={updateRowData}
      />
      <AddNewProductModal
        shouldDisableDate={false}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
};

export default FutureMonth;
